import React, {useMemo} from "react";
import {getElementOffset} from "../../tools/index";
import DownloadBlock from "../../commonUI/DownloadBlock";
import {currentLocale, getString} from "../../index";
import CommonQuestionModal from "../../components/CommonQuestionModal";
import {App} from "../../App";
import css from "./index.module.less";
import Constant from "../../utils/Constant";
import {isiOS} from "../../utils";

const $st = getString;

export function DownloadPhoneView() {
    const [modalVisible, setModalVisible] = React.useState(false);
    const [modalHeight, setModalHeight] = React.useState(795);

    React.useEffect(() => {
        const ele = document.getElementById("modalBottomLine");
        const eleOffset = getElementOffset(ele);
        const documentHeight = document.body.clientHeight;

        setModalHeight(documentHeight - eleOffset.top);
    }, []);

    const url = useMemo(() => {
        if (isiOS()) {
            return $st("testflight_url")
        } else {
            return `${Constant.pionexApkHost}/apk/pionex.apk`;
        }
    }, [currentLocale]);

    return (
        <App hideHeader={true}>
            <div className="App">
                <div className={css.title}>{getString("slogan")}</div>

                <div className={css.downloadArea}>
                    <DownloadBlock
                        title={getString("download_item_name")}
                        subTitle={
                            isiOS()
                                ? getString("download_item_desc")
                                : getString("download_android_item_desc")
                        }
                        downloadUrl={url}
                        onClick={() => {
                            if (isiOS()) {
                                setModalVisible(true);
                            }
                        }}
                    />

                    {isiOS() && (
                        <div className="downloadHelp">
              <span style={{fontSize: 12}}>
                {getString("download_item_question") + " "}
                  <span
                      onClick={() => setModalVisible(true)}
                      style={{color: "#2C75FF"}}
                  >
                  {getString("download_item_click_tip")}
                </span>
              </span>
                        </div>
                    )}
                </div>
                <div id="modalBottomLine"/>

                <div className="bottomWrap">
                    <img
                        style={{width: "100%", height: "100%"}}
                        src={require("../../images/app&web_pic_cut.png")}
                        alt="app&web_pic_cut"
                    />
                </div>

                <CommonQuestionModal
                    modalVisible={modalVisible}
                    setModalVisible={setModalVisible}
                    modalHeight={modalHeight}
                />
            </div>
        </App>
    );
}
